import { Fragment, useEffect, useRef, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { ChevronDownIcon, PlusIcon } from "@heroicons/react/outline";
import useGetHook from "../../customHooks/useGetHook";

export default function ProductTypeComboboxInput(props: any) {
  const {
    url,
    queryKey,
    props: otherProps,
    errors,
    setValue,
    name,
    getValues,
    clearErrors,
    disabled=false,
    value=null,
  } = props;
  const limit: number = 10;
  const [query, setQuery] = useState("");
  const comboboxButtonRef = useRef<HTMLButtonElement>(null);
  const [selected, setSelected] = useState<any>("");
  const [data, setData] = useState([]);
  useEffect(() => {
    setValue(name, selected?.id ?? null);
  }, [selected]);

  useEffect(()=>{
    if (!selected && value) {
      setSelected({...value})
    }
  },[value])

 
  const { data: serverData } = useGetHook({
    queryKey: [queryKey, `${queryKey}-${limit}-${query}`],
    url: url,
    params: {
      limit: limit,
      offset: 0,
      search: query,
      ...otherProps,
    },
  });
  useEffect(() => {
    if (Array.isArray(serverData?.results)) {
      setData(serverData?.results ?? []);
    }
  }, [serverData]);
  return (
    <>
      <Combobox value={selected} disabled={disabled} onChange={setSelected}>
        <div className="relative mt-3">
          <label>{props?.label}</label>

          <div className="relative w-full cursor-default overflow-hidden  bg-white text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm mt-2">
            <Combobox.Input
              className="w-full focus:outline-none bg-[#EEF5F4] p-[10px] text-left"
              placeholder={props?.placeholder}
              onBlur={()=>clearErrors(name)}
              displayValue={(person: any) => person?.name}
              onChange={(event) => setQuery(event.target.value)}
              onClick={() => { comboboxButtonRef?.current?.click(); }}
            />
            <Combobox.Button ref={comboboxButtonRef} className="absolute inset-y-0 right-0 flex items-center pr-2">
              {selected && <PlusIcon
                className="h-5 w-5 text-gray-400 rotate-45"
                aria-hidden="true"
                onClick={() => setSelected("")}
              />}
              <ChevronDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery("")}
          >
            <Combobox.Options className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {data.length === 0 && query !== "" ? (
                <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                data.map((person: any, index:number) => (
                  <Combobox.Option
                    key={index}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? "bg-primary text-white" : "text-gray-900"
                      }`
                    }
                    value={person}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate ${selected ? "font-medium" : "font-normal"
                            }`}
                        >
                          {person.name}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? "text-white" : "text-teal-600"
                              }`}
                          >
                            {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
          {errors && (
            <p className="text-red-500 text-xs my-1">{errors?.message}</p>
          )}
        </div>
      </Combobox>
    </>
  );
}
